import { createContext, useContext } from "react";

import type { AppBrandingDto } from "@/api/types";

export interface ProjectContextData {
  projectId: ProjectId;
  projectSlug: string;
  projectAppBranding?: AppBrandingDto;
}

export const ProjectContext = createContext<ProjectContextData | undefined>(undefined);

export function useOptionalProjectContext(): ProjectContextData | undefined {
  return useContext(ProjectContext);
}

export function useProjectContext(): ProjectContextData {
  const context = useOptionalProjectContext();
  if (!context) {
    throw new Error("Project scope is missing");
  }

  return context;
}

/**
 * Branded type for type safety. In javascript just a string.
 */
export type ProjectId = string & { __brand: "projectId" };
